import { render, staticRenderFns } from "./course-online-list.vue?vue&type=template&id=b7c94a02&scoped=true&"
import script from "./course-online-list.vue?vue&type=script&lang=js&"
export * from "./course-online-list.vue?vue&type=script&lang=js&"
import style0 from "./course-online-list.vue?vue&type=style&index=0&id=b7c94a02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c94a02",
  null
  
)

export default component.exports